export const API_LOGIN = 'LOGIN';
export const API_LOGIN_REQUEST = 'LOGIN_REQUEST';
export const API_LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const API_LOGIN_FAILURE = 'LOGIN_FAILURE';
export const API_LOGOUT = 'LOGOUT';
export const API_LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const API_LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const API_LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const API_READ_SESSION = 'GET_SESSION';
export const API_READ_SESSION_REQUEST = 'GET_SESSION_REQUEST';
export const API_READ_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const API_READ_SESSION_FAILURE = 'GET_SESSION_FAILURE';

export type API_LOGIN = typeof API_LOGIN;
export type API_LOGIN_REQUEST = typeof API_LOGIN_REQUEST;
export type API_LOGIN_SUCCESS = typeof API_LOGIN_SUCCESS;
export type API_LOGIN_FAILURE = typeof API_LOGIN_FAILURE;
export type API_LOGOUT = typeof API_LOGOUT;
export type API_LOGOUT_REQUEST = typeof API_LOGOUT_REQUEST;
export type API_LOGOUT_SUCCESS = typeof API_LOGOUT_SUCCESS;
export type API_LOGOUT_FAILURE = typeof API_LOGOUT_FAILURE;
export type API_READ_SESSION = typeof API_READ_SESSION;
export type API_READ_SESSION_REQUEST = typeof API_READ_SESSION_REQUEST;
export type API_READ_SESSION_SUCCESS = typeof API_READ_SESSION_SUCCESS;
export type API_READ_SESSION_FAILURE = typeof API_READ_SESSION_FAILURE;
